import { encode as base64_encode } from "base-64";

import { postApi } from "../components/Utility";
import { action, makeObservable, observable } from "mobx";
import config from "../config";

class DistributorStore {
  distributors = [];
  rootStore;

  constructor(rootStore) {
    makeObservable(this, {
      distributors: observable,
      distributorList: action,
      setDistributor: action,
      getDistributorData: action,
    });
    this.rootStore = rootStore;
  }

  setDistributor(value) {
    this.distributors = value;
  }

  async distributorList() {
    var postData = { type: "Distributor", companyId: null };
    const base64Input = await base64_encode(JSON.stringify(postData));
    // var response = await postApi
    //   .getClient()
    //   .post("index.php?c=company&a=getdistributors", "postData=" + base64Input);
    var response = await postApi
      .getClient("")
      .get(config.NodeUrl + "/company/get-distributors", {
        params: postData,
      });
    let distributors = [{ companyId: -1, name: "All" }];
    distributors = [...distributors, ...response?.data?.data?.companies];
    this.setDistributor(distributors);
  }
  getDistributorData() {
    console.log("compay", this.getDistributorData);
    // return this.companyData
  }
}

export default DistributorStore;
